export const environment = {
  production: true,
  name: 'staging',
  appDomain: 'interculturalist-test.fi',
  appKey: 'interculturalist',
  imageHostIdentifier: 'cebt-staging',
  appUrl: 'https://interculturalist.org',
  apiProxyDomain: '',
  apiUrl: 'https://cebt-test.fi',
};
// For instructions how to use environment files, see the comments in the environment.ts file.
